import * as React from 'react';
import Link from 'components/Link';
import Image from 'components/Image';
import { withRouter } from 'app/context/Router';
import { withDocumentTitle } from 'lib/documentTitle';
import ModalTrigger from 'components/ModalTrigger';
import SupportDialog from 'support/components/SupportDialog';

import './styles/NotFoundPage.scss';

type Props = {
  router: {
    goBack: Function;
    replace: Function;
  };
};

class NotFoundPage extends React.Component<Props> {
  goBack = () => {
    if (!this.props.router) {
      // We aren't in a Route Handler, so use browser API to relocate
      window.location.replace('/classes');
      return;
    }

    if (window.history.length > 1) {
      this.props.router.goBack();
    } else {
      this.props.router.replace('/');
    }
  };

  render() {
    return (
      <div className="NotFoundPage">
        <div className="NotFoundPage-content">
          <Image
            className="NotFoundPage-image"
            src={require('assets/images/emoji-grin.svg')}
            alt="This is embarrassing"
          />

          <div className="NotFoundPage-title">Uh oh! Something went wrong.</div>
          <div className="NotFoundPage-subtext">
            <Link
              onClick={this.goBack}
              data-test="go-back-button"
              className="NotFoundPage-link"
              eventElementName="NotFoundPage-link"
            >
              Go back
            </Link>
            <span> or </span>
            <ModalTrigger modal={<SupportDialog />}>
              <Link className="NotFoundPage-link" eventElementName="NotFoundPage-link">
                get help
              </Link>
            </ModalTrigger>
            .
          </div>
        </div>
      </div>
    );
  }
}

export { NotFoundPage };
export default withRouter(withDocumentTitle('Not found', NotFoundPage));
